import {
  dateTimeFormatter, localeFormatter,
  statusFormatter,
} from '../../../utils/formatters';
import { getViolationStatusDisplayValue, VIOLATION_STATUS_NAMES } from '../../../configs';

export const violationColumns = [
  // {
  //   dataField: 'date',
  //   text: 'violation.date',
  //   headerClassName: 'created-at',
  //   disableSort: true,
  //   formatter: dateTimeFormatter,
  // },
  // {
  //   dataField: 'uuid',
  //   text: 'ИД',
  //   disableSort: true,
  // },
  {
    dataField: 'violation_type',
    text: 'violation.type',
    disableSort: true,
    formatter: t => localeFormatter('violation.type', t),
  },
  {
    dataField: 'vehicle_id',
    text: 'ИД ТС',
    disableSort: true,
  },
  {
    dataField: 'vehicle_type',
    text: 'vehicles.vehicle_type',
    disableSort: true,
    formatter: t => (t ? localeFormatter('vehicle.types', t) : ''),
  },
  {
    dataField: 'inspector_login',
    text: 'violation.inspector_login',
    headerClassName: 'user-column',
    disableSort: true,
  },
  {
    dataField: 'description',
    headerClassName: 'user-column',
    disableSort: true,
  },
  {
    dataField: 'provider_name',
    text: 'Провайдер',
    headerClassName: 'user-column',
    disableSort: true,
  },
  {
    dataField: 'zone_name',
    text: 'violation.zone',
    headerClassName: 'user-column',
    disableSort: true,
  },
  {
    dataField: 'location',
    headerClassName: 'user-column',
    disableSort: true,
    formatter: c => (Array.isArray(c?.coordinates) ? c?.coordinates.toString() : ''),
  },
  {
    dataField: 'status',
    text: 'Статус нарушения',
    headerClassName: 'status-column',
    disableSort: true,
    formatter: a => statusFormatter(getViolationStatusDisplayValue(a), 'violation.status', VIOLATION_STATUS_NAMES),
  },
  {
    dataField: 'updated_at',
    text: 'Дата обновления',
    headerClassName: 'created-at',
    disableSort: true,
    formatter: (value, row) => dateTimeFormatter(value || row?.created_at),
  },
  {
    dataField: 'created_at',
    text: 'Дата создания',
    headerClassName: 'created-at',
    disableSort: true,
    formatter: dateTimeFormatter,
  },
];

export const violationAdditionalColumns = [
  {
    dataField: 'uuid',
    text: 'ИД',
    disableSort: true,
  },
];
